// extracted by mini-css-extract-plugin
module.exports = {"areaList":"area-list-popup_areaList__16sfq","areaUnit":"area-list-popup_areaUnit__3xyVY","icon":"area-list-popup_icon__3QYev"};